"use client"
import type React from "react"
import { TextBody } from "../Text"

type ListGroupProps = {
  groupLabel: string
  children: React.ReactNode
}

export const ListGroup = ({ groupLabel, children }: ListGroupProps) => {
  return (
    <div>
      <div className="px-4 py-3">
        <TextBody weight="semibold">{groupLabel}</TextBody>
      </div>
      {children}
    </div>
  )
}
